var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "mMenusRef",
    staticClass: "mMenus",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "mMenu-bg",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/menu-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_c('span', {
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/menu-home-${_vm.selectMenu == 'home' ? 1 : 2}.png`)}) center/auto 100% no-repeat`
    }
  })]), _c('div', {
    staticClass: "mMenu-main"
  }, _vm._l(_vm.menuList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "mMenu-item",
      class: [_vm.selectMenu == item.value && 'active'],
      on: {
        "click": function ($event) {
          return _vm.onMenu(item);
        }
      }
    }, [_c('div', {
      staticClass: "mMenu-item-main"
    }, [_c('div', {
      staticClass: "menu-item-icon"
    }, [_c('svg-icon', {
      attrs: {
        "name": `icon-${item.value}`
      }
    })], 1), _c('div', {
      staticClass: "mMenu-item__label"
    }, [_vm._v(_vm._s(item.label) + " " + _vm._s(_vm.selectMenu.value))])])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };